<template>
    <div class="w-full lg:w-1/2 md:w-full shadow-lg rounded-lg overflow-hidden">
        <div class="py-3 px-5 bg-gray-50">Monthly Revenue Chart

            <Bar
                id="barChat"
                :options="chartOptions"
                :data="chartData"

            />
        </div>
    </div>
</template>
<script>
import {Bar} from 'vue-chartjs'
import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
    name: 'BarChart',
    components: {Bar},
    props: {
        monthlyRevenue : Array
    },
    data() {

        let labels = Object.keys(this.monthlyRevenue);
        let values = Object.values(this.monthlyRevenue);
        return {
            chartData: {
                labels: labels,
                datasets: [
                    {
                        label: 'Month Revenue Chart',
                        backgroundColor: "hsl(252, 82.9%, 67.8%)",
                        data: values
                    }
                ]
            },
            chartOptions: {
                responsive: true
            }
        }
    },
}
</script>
